import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface RadioProps extends FormlyFieldProps {
    formCheck?: 'default' | 'inline';
}

@Component({
    standalone: false,
    selector: "formly-field-radio",
    templateUrl: "./radio.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldRadio extends FieldType<FieldTypeConfig<RadioProps>> {

    override defaultOptions = {
        props: {
            formCheck: 'default' as const,
        },
    };

    private readonly disabledControlSnapshot = new FormControl({ value: '', disabled: true });

    get disabledControl(): FormControl {
        this.disabledControlSnapshot.setValue(this.formControl.value, { emitEvent: false });
        return this.disabledControlSnapshot;
    }

}